import { matchPath } from 'react-router';

export const isActiveRoute = (pathname: string, paths: string[] = []) => {
  return paths.some((path) => matchPath(path, pathname));
};
